const awsExport = {
    Auth: {
        region: "eu-west-1",
        userPoolId: "eu-west-1_nVUUWergw",
        userPoolWebClientId: "lufgvkmgh8pb7fjorv7da12rp",
    },
};

export default awsExport;